export default "__VITE_ASSET__2K_le3HU__"